import moment from 'moment-timezone'

// convert Firebase timestamp to this format '2024-04-21'
export function convertTimestampToDate(timestamp) {
  return moment(timestamp.toDate()).format('YYYY-MM-DD')
}

export function getHourFromTimestamp(timestamp) {
  return moment(timestamp.toDate()).hours()
}
